
import Vue from "vue";
import { Menu } from "@ambii-com/core";
import SelectedMenuChip from "~/components/pages/appointment/SelectedMenuChip.vue";

export default Vue.extend({
  components: { SelectedMenuChip },
  props: {
    dialog: Boolean,
    width: String,
    selectedMenu: Menu,
    selectedSubmenu: {
      type: Menu,
      required: false,
    },
    noticeHTML: String,
    hideNoticeDialogClass: String,
  },
  data(): {
    locale: string;
  } {
    return {
      locale: this.$i18n.locale,
    };
  },
  computed: {
    dialogTransition(): string {
      return !!this.selectedSubmenu ? "" : "dialog-transition";
    },
    dialogOverlay(): boolean {
      return !!this.selectedSubmenu ? true : false;
    },
  },
});
